/**
 * QuickReplyPills Component
 *
 * Displays optional quick reply suggestions as small pills.
 * These are NOT checkboxes - they're optional conversation starters
 * that can be ignored. User can always type their own response.
 */

import { cn } from '@/lib/utils'

interface QuickReplyPillsProps {
  replies: string[]
  onSelect: (reply: string) => void
  disabled?: boolean
  className?: string
}

export function QuickReplyPills({
  replies,
  onSelect,
  disabled = false,
  className,
}: QuickReplyPillsProps) {
  if (!replies || replies.length === 0) {
    return null
  }

  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      {replies.map((reply, index) => (
        <button
          key={index}
          onClick={() => onSelect(reply)}
          disabled={disabled}
          className={cn(
            'px-3.5 py-2 text-sm rounded-lg',
            'border border-border bg-surface',
            'text-text-secondary hover:text-text',
            'hover:bg-warm-50 hover:border-warm-400',
            'shadow-sm transition-all duration-200',
            'disabled:opacity-50 disabled:cursor-not-allowed',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-warm-400 focus-visible:ring-offset-2'
          )}
        >
          {reply}
        </button>
      ))}
    </div>
  )
}
